import schema from './schema';
export default {
  algolia: {
    applicationId: 'TO2F04TXTS',
    searchOnlyApiKey: 'e37dcec3965d1cabde303b17e65d25f0',
    prefix: 'firebaseSSRStarter',
  },
  firebase: {
    apiKey: 'AIzaSyBRLf1WkEBxAw5owXqTTlFIIjYNR1hoatg',
    authDomain: 'fir-ssr-starter.firebaseapp.com',
    databaseURL: 'https://fir-ssr-starter.firebaseio.com',
    projectId: 'fir-ssr-starter',
    storageBucket: 'fir-ssr-starter.appspot.com',
    messagingSenderId: '58348257612',
  },
  notifications: {
    ADMIN: 'admin',
    MESSAGE: 'message',
  },
  schema,
};



// WEBPACK FOOTER //
// ./environments/environment.js